import { render, staticRenderFns } from "./roomTypeList.vue?vue&type=template&id=48f88ed5&scoped=true"
import script from "./roomTypeList.vue?vue&type=script&lang=js"
export * from "./roomTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f88ed5",
  null
  
)

export default component.exports